import { makePostRequest } from 'owa-ows-gateway';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { isSuccessStatusCode } from 'owa-http-status-codes';
import { getGuid } from 'owa-guid';

const GET_IP_LOC_ENDPOINT: string = 'ows/GetIpLoc';

export async function getIpLoc(): Promise<string | null> {
    // For Ip location request, Outlook always honors the global account.
    const globalSettingsMailboxInfo = getGlobalSettingsAccountMailboxInfo();
    const correlationId = getGuid();

    const rawResponse = await makePostRequest(
        GET_IP_LOC_ENDPOINT,
        'getIpLoc',
        correlationId,
        true /*returnFullResponse*/,
        undefined /*headers*/,
        undefined /*throwServiceError*/,
        undefined /*sendPayloadAsBody*/,
        undefined /*includeCredentials*/,
        'getIpLoc' /*actionName*/,
        undefined,
        globalSettingsMailboxInfo
    );

    if (!!rawResponse && isSuccessStatusCode(rawResponse.status)) {
        const response = await rawResponse.text();
        if (response && typeof response === 'string') {
            // Drop invalid responses
            if (response === 'NullIPHeader' || response === 'EmptyIPHeader') {
                return null;
            }

            // Parse format: "{countryIso},{state}"
            const parts = response.split(',');
            if (parts.length === 2) {
                const [countryIso, state] = parts;
                // Ensure all parts are present (not empty strings)
                if (countryIso && state) {
                    return `${countryIso},${state}`;
                }
            }
        }
    }

    return null;
}
